export default __webpack_public_path__ + "static/media/avidemux-filters.cab5a131.jpg";